<template>
  <div
    :id="name"
    :data-field="name"
    :class="[
      { 'form-item-vertical-wrap': true },
      { error: feedbackStatus },
      { bottom: marginBottom },
      { noPadding: noPadding },
      { noPaddingTop: noPaddingTop },
      { borderRadiusTop: borderRadiusTop },
      { borderRadiusBottom: borderRadiusBottom },
      direction,
    ]"
  >
    <div class="form-item-inner-wrap">
      <div class="form-item-top-content">
        <div v-if="label" class="form-item-label">
          <div class="label-text-wrap">
            <span v-if="asterisk" class="form-item-asterisk">*</span>
            <label class="form-item-label-text">{{ label }}</label>
          </div>
        </div>
        <div class="form-item-content">
          <slot />
        </div>
      </div>
      <div v-if="feedbackStatus" class="form-item-feedback">
        {{ feedbackText }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  props: {
    name: {},
    asterisk: {},
    label: {},
    extra: {},
    message: {},
    feedbackText: {},
    feedbackStatus: {}, // 'error' | 'warning' | 'success' | 'pending'

    icon: {},
    arrow: {},
    marginBottom: {},
    noPadding: {},
    noPaddingTop: {},
    borderRadiusTop: {},
    borderRadiusBottom: {},
    direction: {}, // 'vertical' | 'horizontal'
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
